// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ld-0";